import { useLayoutEffect } from 'react';

/*
set --100vh custom variable on style root

:root{
 --100vh: 100vh
}

*/
var VAR = '--100vh';

// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
var set100VhCssVar = function set100VhCssVar() {
  var vh = window.innerHeight;
  document.documentElement.style.setProperty(VAR, vh + "px");
};
function use100Vh() {
  useLayoutEffect(function () {
    window.addEventListener('resize', set100VhCssVar);
    return function () {
      window.removeEventListener('resize', set100VhCssVar);
    };
  }, []);
  return [set100VhCssVar];
}

export { use100Vh };
